import { useLocation } from 'react-router-dom'
import { customerData } from '../../../utilities/CustomerData'
import { apiURL } from '../../../utilities/URLs'

export function DashboardResyncIDME({ isPage, idmeError }) {
  const location = useLocation()
  const { isSpouse } = location.state || {}

  const idMeURL = `${process.env.REACT_APP_IDME_API_DOMAIN}/oauth/authorize?client_id=${process.env.REACT_APP_IDME_CLIENT_ID}&redirect_uri=${apiURL}/idme&response_type=code&scope=openid%20http://idmanagement.gov/ns/assurance/ial/2/aal/2&state=resync`

  const handleStartIDme = () => {
    if(!customerData.impersonationMode) {
      localStorage.setItem('idme', '1')
      if(isSpouse)
        localStorage.setItem('idmeSpouse', '1')
    }
    
    window.location.href = idMeURL
  }

  return (
    isPage ? (
      <div className='w-full flex items-center justify-center'>
        <div className='shadow-full rounded-xl p-4 lg:w-fit w-11/12 h-fit mt-48 flex flex-col bg-[#5186C0] font-mont text-white'>
          <div className='w-full max-sm:scale-90 flex flex-col items-center'>
            <p className='font-bold text-3xl text-center mt-4'>Re-Sync Your {isSpouse ? "Spouse's" : ''} ID.me Account</p>
            <div className='flex flex-col items-center gap-4 mt-10'>
              <p>We need to reconnect to your {isSpouse ? "spouse's" : ''} ID.me account to continue. Please click the button below to re-sync your {isSpouse ? "spouse's" : ''} account and restore access. We apologize for this delay.</p>
              {idmeError && (
                <p className='text-red-500'>{idmeError}</p>
              )}
              <div className='flex justify-center w-full'>
                <button onClick={handleStartIDme}>
                  <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div className='lg:w-full w-11/12 flex flex-col gap-4 mt-4'>
        <div className='shadow-md p-6 rounded-xl w-full h-fit flex flex-col bg-[#5186C0] font-mont text-white'>
          <div className='w-full max-sm:scale-90 flex flex-col items-center'>
            <div className='flex flex-col items-center gap-4'>
              <div className='flex justify-center w-full'>
                <button onClick={handleStartIDme}>
                  <img className='w-56 h-11' src='https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/verify.svg' />
                </button>
              </div>
              <p className='font-bold text-xl'>We need to reconnect to your ID.me account to continue. Please click the button below to re-sync your account and restore access. We apologize for this delay.</p>
            </div>
          </div>
        </div>
      </div>
    )
  )
}